import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Box, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';
import EditIcon from '@mui/icons-material/Edit';
import { updateMfproductorderInfo } from '../MfproductorderAPI';
import { updateMfproductorderObj } from 'store/slice/ManufSlice';

export default function MfproductorderInfo() {
  const dispatch = useDispatch();
  const { mfproductorderObj } = useSelector((state) => state.manufslice.mfproductorderDashboard);

  // State for dialog and matter value
  const [open, setOpen] = useState(false);
  const [matter, setMatter] = useState('');

  // Open dialog and set current matter
  const handleEditClick = () => {
    setMatter(mfproductorderObj.matter ?? '');
    setOpen(true);
  };

  // Save handler (add redux update logic if needed)
  const handleSave = () => {
    updateMfproductorderInfo(mfproductorderObj.id, {'matter':matter },
      (response) => {
        dispatch(updateMfproductorderObj(response));
      },
      (error) => {
        // Handle error
        console.error('Error updating matter:', error);
      } 
    );
    setOpen(false);
  };

  return (
    <Box lg={12} sx={{ flexGrow: 1 }}>
      <Grid item sx={{ overflowY: "scroll", height: '100%' }}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          sx={{ backgroundColor: 'white', width: '100%' }}
        >
          <Grid item lg={4} xs={6}><FieldView2 label="Order Id" value={mfproductorderObj.orderid ?? 'NOT KNONWN'} /></Grid>
          <Grid item lg={4} xs={6}><FieldView2 label="Party Name" value={mfproductorderObj.partyname ?? 'NOT KNONWN'} /></Grid>
          <Grid item lg={4} xs={6}><FieldView2 label="Product Name" value={mfproductorderObj.productname ?? 'NOT KNONWN'} /></Grid>
          <Grid item lg={4} xs={6}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <FieldView2 label="Matter" value={mfproductorderObj.matter ?? 'NOT KNONWN'} />
              <EditIcon
                sx={{ p: .25, m: 1, cursor: 'pointer', backgroundColor: 'secondary.100', width: '35px', height: '35px', borderRadius: 2 }}
                onClick={handleEditClick}
              />
            </Box>
          </Grid>
          <Grid item lg={4} xs={6}><FieldView2 label="Qty" value={mfproductorderObj.qty ?? 'NOT KNONWN'} /></Grid>
          <Grid item lg={4} xs={6}><FieldView2 label="Delivery Priority Name" value={mfproductorderObj.deliverypriorityname ?? 'NOT KNONWN'} /></Grid>
          <Grid item lg={4} xs={6}><FieldView2 label="Expected Delivery" value={mfproductorderObj.expecteddelivery ? mfproductorderObj.expecteddelivery.split('T')[0] : 'NOT KNONWN'} /></Grid>
          <Grid item lg={4} xs={6}><FieldView2 label="Stitching Status Name" value={mfproductorderObj.stitchingstatusname ?? 'NOT KNONWN'} /></Grid>
          <Grid item lg={4} xs={6}><FieldView2 label="Remarks" value={mfproductorderObj.remarks ?? 'NOT KNONWN'} /></Grid>
        </Grid>
      </Grid>

      {/* Edit Matter Dialog */}
      <Dialog open={open} onClose={() => setOpen(false)} PaperProps={{ sx: { minWidth: 300 } }}>
        <DialogTitle>Edit Matter</DialogTitle>
        <DialogContent>
          <TextField
            label="Matter"
            value={matter}
            onChange={e => setMatter(e.target.value)}
            fullWidth
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={handleSave} variant="contained" disabled={matter.trim() === ''}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}